import styled from 'styled-components';
import { StyledContainer } from '../../tableItemDetailViewComponents/Containers';

export const FormContainer = styled.div`
  container-type: inline-size;
  padding-bottom: 24px;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
`;

export const FormCard = styled(StyledContainer)`
  padding: 16px;
  gap: 24px;
  display: flex;
  flex-direction: column;
  width: 600px;
  margin: 16px auto;
  box-sizing: border-box;

  @container (max-width: 600px) {
    width: 100%;
  }
`;

export const FormFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
